import React from 'react';

function CopyDefault({ fill = '#1D1C1D', width = 20, height = 20, ...rest }) {
  return (
    <svg width={width} height={height} {...rest} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.75 18.3125C3.41667 18.3125 3.125 18.1875 2.875 17.9375C2.625 17.6875 2.5 17.3959 2.5 17.0625V4.50004H3.75V17.0625H13.625V18.3125H3.75ZM6.25 15.8125C5.91667 15.8125 5.625 15.6875 5.375 15.4375C5.125 15.1875 5 14.8959 5 14.5625V2.89587C5 2.56254 5.125 2.27087 5.375 2.02087C5.625 1.77087 5.91667 1.64587 6.25 1.64587H15.4167C15.75 1.64587 16.0417 1.77087 16.2917 2.02087C16.5417 2.27087 16.6667 2.56254 16.6667 2.89587V14.5625C16.6667 14.8959 16.5417 15.1875 16.2917 15.4375C16.0417 15.6875 15.75 15.8125 15.4167 15.8125H6.25ZM6.25 14.5625H15.4167V2.89587H6.25V14.5625Z" fill={fill} />
    </svg>

  );
}

export default CopyDefault;
